export default __webpack_public_path__ + "static/media/explorer-kraver-2.1de4b48b.svg";